import { makeModuleStateSelector } from "@client/content/selectors";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type MemberProfile } from "./types";

export const localStateSelector = makeModuleStateSelector<MemberProfile.AppState>(defaultState, previewState);

export const localStateFieldErrorSelector = createSelector([localStateSelector], (localState) => localState.fieldError);

export const localStateProfileSelector = createSelector([localStateSelector], (localState) => localState.profile);

export const localStateHasProfileSelector = createSelector([localStateSelector], (localState) => localState.hasProfile);
